import React, { Component } from "react"
import theme from "../styles/theme"
import styled from "@emotion/styled"

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 32px;
  align-items: center;
  max-width: ${theme.maxwidth.default};
  margin-left: auto;
  margin-right: auto;
  color: #fff;
  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`

const Content = styled.div`
  width: 100%;
  h4 {
    color: #fff;
    position: relative;
    line-height: 1.8;
    padding: 64px 0 64px 0;
    &:before {
      color: #7ceff3;
      content: open-quote;
      position: absolute;
      font-size: 100px;
      top: -32px;
      left: -32px;
      font-style: italic;
      height: 20px;
    }
    &:after {
      color: #7ceff3;
      content: close-quote;
      position: absolute;
      font-size: 100px;
      bottom: 32px;
      right: 32px;
      font-style: italic;
      height: 20px;
    }
  }
`
const Details = styled.div`
  p {
    margin: 0;
    color: #fff;
  }
`
const Slogan = styled.div`
  width: 100%;
  h2 {
    color: #fff;
  }
`

export default class MediaFeature extends Component {
  render() {
    const Outer = styled.div`
      padding: 64px 32px;
      background: ${theme.color.extended.blue};
      margin-top: ${props => (this.props.padding ? "64px" : "0px")};
    `
    return (
      <Outer>
        <Container>
          <Slogan>
            <h2>See how startups use Stack to formalize their sales process</h2>
          </Slogan>
          <Content>
            <h4>{this.props.quote}</h4>
            <Details>
              <p>{this.props.position}</p>
              <p>{this.props.name}</p>
            </Details>
          </Content>
        </Container>
      </Outer>
    )
  }
}
